// StatusSummaryCards.tsx

import { Box, Grid2, Paper, Stack, Typography, CircularProgress } from '@mui/material';
import { TECHNICIANVIEWSTATUS } from '../../utils/TechnicianConst';
import { TechnicianStyle } from './TechnicianStyle';
import { useCountsSPLotStatus } from '../../api/vegApl/Technician';
import { useEffect, useState } from 'react';
import { useGlobalState } from "../../contexts/GlobalState";
import { useSnackbar } from '../../contexts/SnackbarContext';
import { useCommonStyles } from '../../styles/GenericStyle';

export type StatusProps = {
  crop: string | null,
  setCardType: (data: any) => void;
}


export default function StatusSummaryCards({ crop, setCardType }: StatusProps) {
  const { state: globalState } = useGlobalState();
  const { showSnackbar } = useSnackbar();
  const [spLotStatus, setSPLotStatus] = useState<any | null>({
    "Processing": 0,
    "Idle": 0,
    "Completed": 0,
    crop_code: "",
    site_code: "",
  });
  const classes = useCommonStyles();
  const [isLoading, setIsLoading] = useState(false);
  const { mutate: countsSPLotStatus } = useCountsSPLotStatus({
    mutation: {
      onSuccess: (data: any) => {
        let tmpData = data?.data;
        setSPLotStatus({
          "Processing": tmpData?.SpLotInProgressCount ?? 0,
          "Idle": tmpData?.SplotNotStartedCount ?? 0,
          "Completed": tmpData?.SplotCompletedCount ?? 0,
          crop_code: crop ?? "",
          site_code: globalState.allocatedSites?.[0]?.full_code ?? "",
        })
        setIsLoading(false);
      },

      onError: (error: any) => {
        let errorMessage = (error?.response?.data?.detail) || "Error";
        showSnackbar({ message: errorMessage, severity: 'error' });
        setIsLoading(false);
      }
    },
  });

  useEffect(() => {
    console.log("Global allocated sites in TechnicianStatus: ", globalState.allocatedSites[0]);

    if (globalState.allocatedSites?.[0]?.full_code) {
      setIsLoading(true);
      countsSPLotStatus({ site_code: globalState.allocatedSites?.[0]?.full_code, crop_code: crop ?? "" })
    }
    else {

      setSPLotStatus((prev: any) => ({
        ...prev, Processing: 0,
        Idle: 0,Completed: 0,crop_code: crop,site_code: globalState?.allocatedSites?.[0]?.full_code
          
      }))

    }
  }, [globalState.allocatedSites, crop])

  const cardClick = (item: any) => {
    setCardType((prev: any) => ({ ...prev, isShow: !prev.isShow, type: item?.apiFlag, pageTitle: item?.pageTitle }));
  }


  return (
    <Grid2
      container
      spacing={1}
      wrap="wrap"
      sx={{ width: '100%', px: 2 }}>
      {TECHNICIANVIEWSTATUS.map((c, index) => (
        <Grid2 key={index} size={{ xs: 6, sm: 6, md: 12 }}>
          <Paper
            elevation={0}
            sx={() => ({
              backgroundColor: c.color.bg,
              border: `1px solid ${c.color.border ?? 'transparent'}`,
              cursor: "pointer",
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              ...TechnicianStyle().technicianStatus,
            })} onClick={() => cardClick(c)} >

            <Box
              sx={() => ({
                color: c.color.icon,
                ...TechnicianStyle().iconStyle,
                '& img': {
                  display: 'block'
                }
              })}
              aria-hidden>
              <c.icon />
            </Box>
            <Stack spacing={0} sx={{ minWidth: 0 }}>
              {isLoading ? (
                <Box sx={{ display: 'flex', alignItems: 'center', height: '32px' }}>
                  <CircularProgress size={24} sx={{ color: c.color.text }} />
                </Box>
              ) : (
                <Typography
                  component={"span"}
                  className={classes.labelNoto26Bold400_hh}
                  sx={{
                    color: c.color.text,
                    lineHeight: 1.1,
                  }}>
                  {spLotStatus?.[c.title] ?? 0}
                </Typography>
              )}
              <Typography
                component={"span"}
                className={classes.labelNoto16Bold500_hh}
                sx={{
                  mt: 0.25,
                  color: c.color.subText,
                }}>
                {c.title}
              </Typography>
            </Stack>
          </Paper>
        </Grid2>
      ))}
    </Grid2>
  );
}
